export class ProQuint {
    static consonants = 'bdfghjklmnprstvz'.split('');
    static vowels = 'aiou'.split('');
    static encode(buf) {
        const bits = [];
        const buffer = new DataView(buf);
        for (let i = 0; i < buffer.byteLength / 2; ++i) {
            let n = buffer.getUint16(i * 2); //Big Endian (is default)
            let c1 = n & 0x0f, v1 = (n >> 4) & 0x03, c2 = (n >> 6) & 0x0f, v2 = (n >> 10) & 0x03, c3 = (n >> 12) & 0x0f;
            bits.push([
                ProQuint.consonants[c1],
                ProQuint.vowels[v1],
                ProQuint.consonants[c2],
                ProQuint.vowels[v2],
                ProQuint.consonants[c3],
            ].join(''));
        }
        return bits.join('-');
    }
    static decode(str) {
        const bits = str.split('-');
        //buffer = new Buffer(bits.length * 2);
        const buf = new ArrayBuffer(bits.length * 2);
        const buffer = new DataView(buf);
        for (let i = 0; i < bits.length; ++i) {
            let c1 = ProQuint.consonants.indexOf(bits[i][0]), v1 = ProQuint.vowels.indexOf(bits[i][1]), c2 = ProQuint.consonants.indexOf(bits[i][2]), v2 = ProQuint.vowels.indexOf(bits[i][3]), c3 = ProQuint.consonants.indexOf(bits[i][4]);
            buffer.setUint16(c1 + (v1 << 4) + (c2 << 6) + (v2 << 10) + (c3 << 12), i * 2); //Big Endian (is default)
        }
        return buf;
    }
}
